<template>
    <div class="review-user">
        <div class="review-user__inner">
            <div class="review-user__header flex">
                <a-avatar
                    :src="photo.src"
                    :alt="photo.alt"
                    :title="photo.title"
                    :width="50" />
                <div class="review-user__meta">
                    <div class="review-user__author">
                        <span class="review-user__author-name">{{ author }}</span>
                        <span><span> Компания</span> <span class="review-user__company">{{ company }}</span></span>
                    </div>
                    <div class="review-user__date">{{ created_at }}</div>
                </div>
            </div>
            <div class="review-user__body">
                <div class="review-user__text">{{ text }}</div>
            </div>
            <div class="review-user__asks" v-if="asks.length > 0">
                <div class="review-user__ask" v-for="(ask, i) in asks" :key="i">
                    <div class="review-user__ask-inner">
                        <div class="review-user__header flex">
                            <a-avatar
                                :src="ask.photo.src"
                                :alt="ask.photo.alt"
                                :title="ask.photo.title"
                                :width="50" />
                            <div class="review-user__meta">
                                <div class="review-user__author">
                                    <span class="review-user__author-name">{{ ask.author }}</span>
                                </div>
                                <div class="review-user__role">{{ ask.role }}</div>
                            </div>
                        </div>
                        <div class="review-user__body">
                            <div class="review-user__text">{{ask.text }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { AAvatar } from '../ui'

export default {
    name: 'UserReviewCard',
    components: {
        AAvatar,
    },
    props: {
        author: {
            type: String,
            default: '',
        },
        company: {
            type: String,
            default: '',
        },
        photo: {
            type: String,
            default: '',
        },
        created_at: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        asks: {
            type: Array,
            default: () => []
        }
    },
    setup: (props, ctx) => {
        return {}
    },
}
</script>

<style lang="scss" scoped>
    .review-user {
        margin-bottom: 29px;
        &__inner {
            background: #fff;
            border-radius: var(--br-1);
            padding: 30px;

            @include mobile {
                padding: 24px;
            }
        }
        &__meta {
            margin-left: 12px;
        }
        &__author {
            font-size: 14px;
            line-height: 19px;
            color: var(--c-gray-120);
            &-name {
                font-weight: 600;
            }
            &-company {
                font-family: var(--font-secondary);
                font-weight: 400;
            }
        }
        &__date {
            font-size: 14px;
            line-height: 19px;
            color: var(--c-gray-120);
        }
        &__body {
            margin-top: 20px;
        }
        &__text {
            font-size: 16px;
            line-height: 24px;
            color: var(--c-gray-100);
        }
        &__ask {
            margin-top: 26px;
            padding-top: 26px;
            border-top: 1px solid var(--c-gray-700);
            &:first-child {
                border-top: 1px solid var(--c-gray-700) !important;
            }
            &:last-child {
                border-top: 0;
            }
        }
        &__role {
            font-size: 14px;
            line-height: 20px;
            color: var(--c-secondary-200);
        }
    }
</style>